import React, { useCallback, useEffect, useRef, useState } from 'react';

import { downloadSettingExcel } from "src/utils/blob/blobUtil";

import { useKSK1030_R01Store } from './Store_KSK1030_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import useUiuxStore, { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, showWarning } from 'src/utils/toast/toastUtil';
import { getWmsOrderOutPopupList } from 'src/apis/wmsOrderApi';
import { useInfoFormEvents } from 'src/hooks/useInfoFormEvents';
import { InfoCodeSearchFieldConfig } from 'src/types/info-form';

import { deleteKSK1030_R01, downloadExcel_KSK1030_R01, getKSK1030_R01DetailList, getKSK1030_R01LotList, getKSK1030_R01One, getKSK1030_R01TransportHeader, patchKSK1030_R01, postKSK1030_R01 } from "./Api_KSK1030_R01";
import { defaultKSK1030_R01DetailDto, defaultKSK1030_R01HeaderDto, defaultKSK1030_R01LotDto, KSK1030_R01DetailDto, KSK1030_R01Dto, KSK1030_R01HeaderDto, KSK1030_R01LotDto } from './Dto_KSK1030_R01';
import { AgGridReact } from 'ag-grid-react';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { formatDate, validateString } from 'src/utils/string/stringUtil';
import { validateCustomCd } from 'src/utils/grid/GridValidateContent';
import { useCommonCodeValidate } from 'src/utils/commonCode/CommonCodeValidateContext';
import {
	buildCommonCodeRequirements,
	KSK1030_R01_HEADER_ROW_VALIDATE,
} from 'src/utils/commonCode/commonCodeRequirementConfig';


interface Props {
	gridRef: React.RefObject<AgGridReact<KSK1030_R01HeaderDto> | null>;
	lotGridRef: React.RefObject<AgGridReact<KSK1030_R01LotDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<KSK1030_R01DetailDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
}

export const Content_KSK1030_R01 = (props: Props) => {
	const {
		tabList, setMessage,
	} = props;

	const {
		editKSK1030_R01, setEditKSK1030_R01,
		deletedKSK1030_R01DetailList, setDeletedKSK1030_R01DetailList, addDeletedKSK1030_R01DetailList, removeDeletedKSK1030_R01DetailList,
		selectedKSK1030_R01DetailList, setSelectedKSK1030_R01DetailList, removeSelectedKSK1030_R01DetailList,
		KSK1030_R01DetailList, setKSK1030_R01DetailList,
		setOriginalKSK1030_R01DetailList,
		KSK1030_R01LotMap, setKSK1030_R01LotMap,
		setSelectedItemCdForLot,
		setKSK1030_R01LotList,
		setOriginalKSK1030_R01LotList,
		deletedKSK1030_R01LotList,
		setTransportComplete,
		detailFetchTrigger, setDetailFetchTrigger,
		initData,
		warehouseCdListToUseList,
	} = useKSK1030_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { setCodeSearchModalProps } = useUiuxStore();
	const { validateCommonCodeLists } = useCommonCodeValidate();
	const { inoutClassList, inoutTypeList, inoutMethodList, wmsCdList, compCdList, customCdList, warehouseCdList, itemStatusList } = useCommonCodeStore();

	const wmsOrderInfoHandleFocusId = 'inputWmsOrderNo_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'wmsOrderNo',
			category: '출고지시',
			focusId: wmsOrderInfoHandleFocusId,
			responseMapping: {
				wmsOrderNo: 'wmsOrderNo',
				compCd: 'compCd',
				compNm: 'compNm',
				customCd: 'customCd',
				customNm: 'customNm',
				orderDt: 'orderDt',
				deadlineDt: 'deadlineDt',
				logicCenter: 'logicCenter',
				warehouseCd: 'warehouseCd',
				empNo: 'empNo',
				empNm: 'empNm',
				remark: 'remark',
				inoutClass: 'inoutClass',
				inoutMethod: 'inoutMethod',
				closeTag: 'closeTag',
				inoutType: 'inoutType',
				salesOrderNo: 'salesOrderNo',
				dueDt: 'dueDt',
			},
			searchFunction: async (code: string) => {
				const res = await getWmsOrderOutPopupList(code);
				return res.data.data.find(v => v.wmsOrderNo === code);
			},
			extraFilter: () => ({
				wmsOrderNo: editKSK1030_R01?.wmsOrderNo || '',
			}),
			onAfterConfirm: (fields) => {
				setEditKSK1030_R01({ ...defaultKSK1030_R01HeaderDto, ...fields, inoutClass: '230' });
				setDetailFetchTrigger(true);
			},
		},
	];

	const { getFieldHandlers: getWmsOrderFieldHandlers } = useInfoFormEvents({
		editData: editKSK1030_R01,
		setEditData: setEditKSK1030_R01,
		defaultData: { ...defaultKSK1030_R01HeaderDto, inserted: true },
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'KSK1030_R01'
	});

	useFetchActionbarAuth("KSK1030_R01");

	const [clickable, setClickable] = useState(true);
	const prevWmsOrderNoRef = useRef<string | undefined>(undefined);
	const prevWarehouseCdRef = useRef<string | undefined>(undefined);

	const handleExcelClick = useCallback(async () => {
		if (!editKSK1030_R01?.wmsOrderNo) {
			showWarning("선택된 출고정보내역이 없습니다.");
			return;
		}
		setLoadingSpinner(true);
		const response = await downloadExcel_KSK1030_R01('', editKSK1030_R01.wmsOrderNo, editKSK1030_R01.warehouseCd, 0);
		downloadSettingExcel({ responseData: response.data.data, fileName: '출고정보 등록-excel.xlsx' });
		setLoadingSpinner(false);
	}, [editKSK1030_R01, setLoadingSpinner]);

	const fetchOne = useCallback(async () => {
		if (!editKSK1030_R01?.wmsOrderNo) return;
		const response = await getKSK1030_R01One(editKSK1030_R01.wmsOrderNo);
		return response.data.data as KSK1030_R01HeaderDto;
	}, [editKSK1030_R01?.wmsOrderNo]);

	const fetchTransportHeader = useCallback(async () => {
		if (!editKSK1030_R01?.wmsOrderNo) return;
		const response = await getKSK1030_R01TransportHeader(editKSK1030_R01.wmsOrderNo);
		return response.data.data as KSK1030_R01HeaderDto;
	}, [editKSK1030_R01?.wmsOrderNo]);

	const defaultKSK1030_R01HeaderRow = useCallback(() => {
		const logicCenter = wmsCdList[0]?.minorCd ?? '';
		const warehouseCdListToUse = warehouseCdList.filter(value =>
			value.logicCenter === logicCenter && (value.goodsYn === 'Y' || value.productYn === 'Y')
		);
		const inoutClassListToUse = inoutClassList.filter(item => item.minorCd === '230');

		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(KSK1030_R01_HEADER_ROW_VALIDATE, {
				compCdList,
				wmsCdList,
				warehouseCdList: warehouseCdListToUse,
			}),
		);
		if (!commonResult.valid) {
			return { ...defaultKSK1030_R01HeaderDto };
		}

		return {
			...defaultKSK1030_R01HeaderDto,
			inoutClass: inoutClassListToUse.find(value => value.minorCd === '230')?.minorCd || '230',
			inoutType: inoutTypeList.find(value => value.minorCd === 'OUT')?.minorCd || '',
			compCd: compCdList[0].compCd,
			logicCenter,
			warehouseCd: warehouseCdListToUse[0]?.warehouseCd || '',
			inoutMethod: inoutMethodList[0]?.minorCd || '',
			inserted: true,
		};
	}, [
		compCdList, wmsCdList, warehouseCdList, inoutMethodList, inoutClassList, inoutTypeList, validateCommonCodeLists,
	]);

	const defaultKSK1030_R01DetailRow = useCallback(() => {
		return {
			...defaultKSK1030_R01DetailDto,
			itemStatus: itemStatusList[0]?.minorCd || '',
			inserted: true,
		};
	}, [itemStatusList]);

	const defaultKSK1030_R01LotRow = useCallback(() => {
		return {
			...defaultKSK1030_R01LotDto,
			inserted: true,
		};
	}, []);

	const initContainerData = useCallback(() => {
		prevWmsOrderNoRef.current = undefined;
		prevWarehouseCdRef.current = undefined;
		initData();
		removeDeletedKSK1030_R01DetailList();
		removeSelectedKSK1030_R01DetailList();
		setEditKSK1030_R01({ ...defaultKSK1030_R01HeaderRow() });
	}, [initData, removeDeletedKSK1030_R01DetailList, removeSelectedKSK1030_R01DetailList, setEditKSK1030_R01, defaultKSK1030_R01HeaderRow]);

	const fetchSelectedOrder = useCallback(() => {
		const wmsOrderNo = editKSK1030_R01?.wmsOrderNo;
		if (validateString(wmsOrderNo || '')) {
			prevWmsOrderNoRef.current = undefined;
			setDetailFetchTrigger(true);
			return;
		}
		getWmsOrderFieldHandlers('wmsOrderNo')
			.onDoubleClick({ currentTarget: { blur: () => {}, value: '' } } as unknown as React.MouseEvent<HTMLInputElement>);
	}, [editKSK1030_R01, setDetailFetchTrigger, getWmsOrderFieldHandlers]);

	const handleSearchClick = useCallback(() => {
		fetchSelectedOrder();
	}, [fetchSelectedOrder]);

	const handleDeleteClick = useCallback(() => {
		if (deletedKSK1030_R01DetailList.length > 0) {
			removeDeletedKSK1030_R01DetailList(deletedKSK1030_R01DetailList);
			removeSelectedKSK1030_R01DetailList();
			setKSK1030_R01DetailList([...KSK1030_R01DetailList]);
		} else if (selectedKSK1030_R01DetailList.length > 0) {
			addDeletedKSK1030_R01DetailList(selectedKSK1030_R01DetailList);
			removeSelectedKSK1030_R01DetailList(selectedKSK1030_R01DetailList);
		}
	}, [
		selectedKSK1030_R01DetailList,
		deletedKSK1030_R01DetailList,
		addDeletedKSK1030_R01DetailList,
		removeDeletedKSK1030_R01DetailList,
		removeSelectedKSK1030_R01DetailList,
		setKSK1030_R01DetailList,
		KSK1030_R01DetailList,
	]);

	const handleInsertClick = useCallback((_e?: React.MouseEvent, _rowIndex?: number) => {
		// 재고 LOT은 사용자 행 추가 대상이 아님
	}, []);

	const validateInsertData = (header: KSK1030_R01HeaderDto, detailList: KSK1030_R01DetailDto[]) => {
		if (!validateString(header.wmsOrderNo)) {
			showWarning('출고지시항목을 선택해서 저장해주세요.'); return false;
		}
		if (!validateString(header.compCd)) {
			showWarning('사업장을 선택해주세요.'); return false;
		}
		if (!validateString(header.customCd)) {
			showWarning('거래처를 입력해주세요.'); return false;
		}
		if (!validateCustomCd(header.customCd, customCdList)) {
			showWarning('거래처가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}
		if (!validateString(header.logicCenter)) {
			showWarning('물류센터를 선택해주세요.'); return false;
		}
		if (!validateString(header.warehouseCd)) {
			showWarning('창고번호를 선택해주세요.'); return false;
		}
		if (!validateString(header.inoutMethod)) {
			showWarning('출고구분을 선택해주세요.'); return false;
		}
		if (detailList.length === 0) {
			showWarning('상세내역을 입력해주세요.'); return false;
		}

		const itemStatusPairs = new Set<string>();
		for (const item of detailList) {
			if (!validateString(item.itemCd)) {
				showWarning('품목코드를 입력해주세요.'); return false;
			}
			if (!validateString(item.itemStatus)) {
				showWarning('품목의 상태를 선택해주세요.'); return false;
			}
			if (item.orderQty <= 0) {
				showWarning('수량을 입력해주세요.'); return false;
			}

			const pair = `${item.itemCd}-${item.itemStatus}`;
			if (itemStatusPairs.has(pair)) {
				showWarning(`품목코드 '${item.itemCd}'와(과) 품목상태 '${item.itemStatus}'의 조합이 중복되었습니다.`);
				return false;
			}
			itemStatusPairs.add(pair);

			if (item.stockQty < item.updateTransportQty) {
				showWarning(`출고량이 재고량보다 클 수 없습니다. - 품목코드: ${item.itemCd}`); return false;
			}
			if (item.orderQty < item.transportQty + item.updateTransportQty) {
				showWarning(`출고량이 주문출고량보다 클 수 없습니다. - 품목코드: ${item.itemCd}`); return false;
			}
		}

		return true;
	};

	const setInfoDetailList = useCallback((header: KSK1030_R01HeaderDto, detailList: KSK1030_R01DetailDto[]) => {
		return detailList.map((value) => ({
			...value,
			compCd: header.compCd,
			customCd: header.customCd,
		}));
	}, []);

	const setInfoLotList = useCallback((lotMap: Map<string, KSK1030_R01LotDto[]>): Record<string, KSK1030_R01LotDto[]> => {
		const filteredLotMap: Record<string, KSK1030_R01LotDto[]> = {};
		lotMap.forEach((lots, key) => {
			const filteredLots = lots.filter(lot => lot.inputOutQty && lot.inputOutQty > 0 && lot.isModified === true);
			if (filteredLots.length > 0) {
				filteredLotMap[key] = filteredLots;
			}
		});
		return filteredLotMap;
	}, []);

	const refetchResponseDetailList = useCallback((responseData: KSK1030_R01Dto) => {
		const defaultItemStatus = defaultKSK1030_R01DetailRow().itemStatus;
		let detailDtoList = responseData.wmsOrderDetailDtoList;
		detailDtoList = detailDtoList.map(value => ({
			...value,
			itemStatus: validateString(value.itemStatus) ? value.itemStatus : defaultItemStatus,
			orderQtyView: value.orderQty - value.transportQty - value.updateTransportQty - value.cancelQty,
		}));
		detailDtoList = detailDtoList.filter(value => value.orderQtyView > 0);
		responseData.wmsOrderDetailDtoList = detailDtoList;
		return responseData;
	}, [defaultKSK1030_R01DetailRow]);

	const handleSaveClick = useCallback(async () => {
		if (!validateInsertData(editKSK1030_R01!, KSK1030_R01DetailList)) {
			return;
		}
		setLoadingSpinner(true);

		const lotMapObject = setInfoLotList(KSK1030_R01LotMap);
		const deletedKSK1030_R01DetailList_Number = deletedKSK1030_R01DetailList.map(value => Number(value));
		let processName = '';
		let newDetailList: KSK1030_R01DetailDto[] = [];
		let responseData: KSK1030_R01Dto = {
			wmsOrderHeaderDto: editKSK1030_R01!,
			wmsOrderDetailDtoList: KSK1030_R01DetailList,
			wmsStockLotDtoList: lotMapObject,
		};

		const wmsOrderNo = editKSK1030_R01?.wmsOrderNo || '';

		if (wmsOrderNo !== '') {
			newDetailList = KSK1030_R01DetailList
				.map(value => ({
					...value,
					transportQty: value.transportQty + value.updateTransportQty,
				}))
				.filter(value => !deletedKSK1030_R01DetailList_Number.includes(value.valueIndex));

			if (newDetailList.length === 0) {
				processName = 'delete';
				const deleteResponse = await deleteKSK1030_R01(wmsOrderNo);
				if (!deleteResponse || !deleteResponse.data.successFlag) { setLoadingSpinner(false); return; }
				if (deleteResponse.data.successFlag) {
					showSuccess('출고내역이 삭제 되었습니다.');
					setMessage('출고내역이 삭제 되었습니다.');
				} else { setLoadingSpinner(false); return; }
			} else {
				processName = 'patch';
				const patchResponse = await patchKSK1030_R01({
					wmsOrderHeaderDto: editKSK1030_R01!,
					wmsOrderDetailDtoList: setInfoDetailList(editKSK1030_R01!, newDetailList),
					wmsStockLotDtoList: lotMapObject,
				});
				if (!patchResponse || !patchResponse.data.successFlag) { setLoadingSpinner(false); return; }

				responseData = patchResponse.data.data[0];
				responseData = refetchResponseDetailList(responseData);

				if (patchResponse?.data?.data?.[0] && patchResponse.data.successFlag) {
					showSuccess('출고내역이 등록 되었습니다.');
					setMessage('출고내역이 등록 되었습니다.');
				}
			}
		} else {
			processName = 'post';
			const postResponse = await postKSK1030_R01({
				wmsOrderHeaderDto: editKSK1030_R01!,
				wmsOrderDetailDtoList: setInfoDetailList(editKSK1030_R01!, KSK1030_R01DetailList),
				wmsStockLotDtoList: lotMapObject,
			});
			if (!postResponse || !postResponse.data.successFlag) { setLoadingSpinner(false); return; }

			responseData = postResponse.data.data[0];
			responseData = refetchResponseDetailList(responseData);

			if (postResponse?.data?.data?.[0] && postResponse.data.successFlag) {
				showSuccess('출고내역이 등록 되었습니다.');
				setMessage('출고내역이 등록 되었습니다.');
			}
		}

		if (processName === 'delete') {
			setEditKSK1030_R01({ ...defaultKSK1030_R01HeaderRow() });
			setKSK1030_R01DetailList([]);
			setOriginalKSK1030_R01DetailList([]);
			setKSK1030_R01LotList([]);
			setOriginalKSK1030_R01LotList([]);
			setKSK1030_R01LotMap(new Map<string, KSK1030_R01LotDto[]>());
			setSelectedKSK1030_R01DetailList([]);
			setSelectedItemCdForLot(null);
		} else if (processName === 'patch' || processName === 'post') {
			if (responseData.wmsOrderHeaderDto!.closeTag === 'Y') {
				setEditKSK1030_R01({ ...defaultKSK1030_R01HeaderRow() });
				setKSK1030_R01DetailList([]);
				setOriginalKSK1030_R01DetailList([]);
				setKSK1030_R01LotList([]);
				setOriginalKSK1030_R01LotList([]);
				setKSK1030_R01LotMap(new Map<string, KSK1030_R01LotDto[]>());
				setSelectedKSK1030_R01DetailList([]);
				setSelectedItemCdForLot(null);
			} else {
				setKSK1030_R01DetailList(responseData.wmsOrderDetailDtoList.map(value => ({
					...value,
					updateTransportQty: 0,
				})));
				setEditKSK1030_R01(responseData.wmsOrderHeaderDto);
				setOriginalKSK1030_R01DetailList(responseData.wmsOrderDetailDtoList);

				if (responseData.wmsStockLotDtoList) {
					const lotMapFromServer = responseData.wmsStockLotDtoList;
					const newLotMap = new Map<string, KSK1030_R01LotDto[]>();

					Object.values(lotMapFromServer).forEach((lotsFromServer) => {
						if (!lotsFromServer) return;
						const groupedByStatus = new Map<string, typeof lotsFromServer>();
						lotsFromServer.forEach(lot => {
							const key = `${lot.itemCd}-${lot.itemStatus}`;
							if (!groupedByStatus.has(key)) {
								groupedByStatus.set(key, []);
							}
							groupedByStatus.get(key)!.push(lot);
						});

						groupedByStatus.forEach((lots, key) => {
							let valueIndex = 1;
							const processedLots = lots.map(lot => ({
								...defaultKSK1030_R01LotDto,
								...lot,
								valueIndex: valueIndex++,
								isModified: false,
								inputOutQty: 0,
							}));
							newLotMap.set(key, processedLots);
						});
					});
					setKSK1030_R01LotMap(newLotMap);
				}

				setSelectedKSK1030_R01DetailList([1 as any]);
				if (responseData.wmsOrderDetailDtoList.length > 0) {
					const firstDetail = responseData.wmsOrderDetailDtoList[0];
					setSelectedItemCdForLot(`${firstDetail.itemCd}-${firstDetail.itemStatus}`);
				} else {
					setSelectedItemCdForLot(null);
				}
				setDetailFetchTrigger(true);
			}
		}

		setDeletedKSK1030_R01DetailList([]);
		setTimeout(() => { setMessage(''); }, 5000);
		setLoadingSpinner(false);
	}, [
		editKSK1030_R01,
		KSK1030_R01DetailList,
		KSK1030_R01LotMap,
		deletedKSK1030_R01DetailList,
		setDetailFetchTrigger,
		defaultKSK1030_R01HeaderRow,
		setInfoDetailList,
		setInfoLotList,
		refetchResponseDetailList,
		setMessage,
		setLoadingSpinner,
		setEditKSK1030_R01,
		setKSK1030_R01DetailList,
		setOriginalKSK1030_R01DetailList,
		setKSK1030_R01LotList,
		setOriginalKSK1030_R01LotList,
		setKSK1030_R01LotMap,
		setSelectedKSK1030_R01DetailList,
		setSelectedItemCdForLot,
		setDeletedKSK1030_R01DetailList,
		customCdList,
	]);

	const handleDetailInfoCode = useCallback((headerData: KSK1030_R01HeaderDto): Partial<KSK1030_R01HeaderDto> => {
		const defaults: Partial<KSK1030_R01HeaderDto> = {};
		defaults.orderDt = formatDate(new Date());

		if (!validateString(headerData.compCd) && compCdList.length > 0) defaults.compCd = compCdList[0].compCd;
		if (!validateString(headerData.inoutMethod) && inoutMethodList.length > 0) defaults.inoutMethod = inoutMethodList[0].minorCd;

		if (!validateString(headerData.logicCenter) && wmsCdList.length > 0) {
			defaults.logicCenter = wmsCdList[0].minorCd;
		}
		defaults.logicCenter = headerData.logicCenter ? headerData.logicCenter : defaults.logicCenter;

		const warehouseCdListToUse = warehouseCdListToUseList(defaults.logicCenter || '');
		if (!validateString(headerData.warehouseCd) && warehouseCdListToUse.length > 0) {
			defaults.warehouseCd = warehouseCdListToUse[0].warehouseCd;
		}
		defaults.warehouseCd = headerData.warehouseCd ? headerData.warehouseCd : defaults.warehouseCd;
		defaults.inoutClass = '230';

		return defaults;
	}, [inoutMethodList, wmsCdList, compCdList, warehouseCdListToUseList]);

	const handleFetchLotList = useCallback(async (itemCd?: string, itemStatus?: string) => {
		const warehouseCd = useKSK1030_R01Store.getState().editKSK1030_R01?.warehouseCd || '';
		if (!warehouseCd) {
			setKSK1030_R01LotMap(new Map<string, KSK1030_R01LotDto[]>());
			return;
		}

		const detailList = useKSK1030_R01Store.getState().KSK1030_R01DetailList;
		const targets = (itemCd
			? [{ itemCd, itemStatus: itemStatus || '' }]
			: detailList.map(d => ({ itemCd: d.itemCd, itemStatus: d.itemStatus }))
		).filter(t => validateString(t.itemCd));

		if (targets.length === 0) {
			setKSK1030_R01LotMap(new Map<string, KSK1030_R01LotDto[]>());
			return;
		}

		setLoadingSpinner(true);
		try {
			const lotResponses = await Promise.all(
				targets.map(t => getKSK1030_R01LotList(warehouseCd, t.itemCd, t.itemStatus))
			);

			const state = useKSK1030_R01Store.getState();
			const newLotMap = itemCd
				? new Map(state.KSK1030_R01LotMap)
				: new Map<string, KSK1030_R01LotDto[]>();

			lotResponses.forEach((response, index) => {
				const target = targets[index];
				const key = `${target.itemCd}-${target.itemStatus}`;
				let valueIndex = 1;
				const lotData = (response.data.data || []).map(value => ({
					...value,
					valueIndex: valueIndex++,
					inputOutQty: value.inputOutQty ?? 0,
					isModified: false,
				}));
				newLotMap.set(key, lotData);
			});

			const currentDetailList = state.KSK1030_R01DetailList;
			const newDetailList = currentDetailList.map(detail => {
				const key = `${detail.itemCd}-${detail.itemStatus}`;
				if (!newLotMap.has(key)) return detail;
				const lotQtySum = newLotMap.get(key)?.reduce((acc, lot) => acc + Number(lot.lotQty || 0), 0) || 0;
				return { ...detail, stockQty: lotQtySum };
			});

			setKSK1030_R01LotMap(newLotMap);
			setKSK1030_R01DetailList(newDetailList);

			if (itemCd) {
				setSelectedItemCdForLot(`${itemCd}-${itemStatus || ''}`);
			}
		} catch (error) {
			console.error("Lot 리스트 조회 중 오류 발생:", error);
			showError("Lot 리스트를 조회하는 중 오류가 발생했습니다.");
		}
		setLoadingSpinner(false);
	}, [
		setKSK1030_R01LotMap,
		setKSK1030_R01DetailList,
		setSelectedItemCdForLot,
		setLoadingSpinner,
	]);

	const handleFetchDetailList = useCallback(async (wmsOrderNo: string, warehouseCd: string, isNewSelection: boolean, _previousOrderNo: string | undefined) => {
		setLoadingSpinner(true);
		if (!warehouseCd) {
			showError('수주 정보의 물류정보의 조건에 맞는 창고 코드를 찾을 수 없어 출고 목록 내역을 조회할 수 없습니다.', 5000);
			setKSK1030_R01DetailList([]);
			setLoadingSpinner(false);
			return [];
		}
		if (!isNewSelection) { setLoadingSpinner(false); return []; }

		try {
			const detailResponse = await getKSK1030_R01DetailList(wmsOrderNo, warehouseCd);
			const detailData = detailResponse.data.data;

			if (detailData && detailData.length > 0) {
				const defaultItemStatus = defaultKSK1030_R01DetailRow().itemStatus;
				const updatedDetails = detailData.map((value) => ({
					...value,
					itemStatus: validateString(value.itemStatus) ? value.itemStatus : defaultItemStatus,
					valueIndex: value.valueIndex,
					orderIndex: value.orderIndex,
					orderIndexSeq: value.orderIndexSeq,
					orderPrice: value.orderPrice,
					orderQtyView: value.orderQty - value.transportQty - value.cancelQty,
					updateTransportQty: 0,
					stockQty: value.stockQty ?? 0,
				}));
				setKSK1030_R01DetailList(updatedDetails);
				setOriginalKSK1030_R01DetailList(detailData);
				setMessage(`${editKSK1030_R01?.compNm || ''}의 출고지시내역 ${detailData.length}건을 조회하였습니다.`);
				setTimeout(() => setMessage(""), 5000);

				setSelectedKSK1030_R01DetailList([updatedDetails[0].valueIndex] as any);
				setSelectedItemCdForLot(`${updatedDetails[0].itemCd}-${updatedDetails[0].itemStatus}`);

				setLoadingSpinner(false);
				return updatedDetails;
			}

			showError('상세내역이 없습니다.');
			setKSK1030_R01DetailList([]);
			setLoadingSpinner(false);
			return [];
		} catch (error) {
			console.error("상세 내역 조회 실패:", error);
			showError('상세 내역을 조회하는 중 오류가 발생했습니다.');
			setKSK1030_R01DetailList([]);
			setLoadingSpinner(false);
			return [];
		}
	}, [
		setMessage,
		setKSK1030_R01DetailList,
		setOriginalKSK1030_R01DetailList,
		editKSK1030_R01?.compNm,
		setSelectedKSK1030_R01DetailList,
		setSelectedItemCdForLot,
		defaultKSK1030_R01DetailRow,
		setLoadingSpinner,
	]);

	useEffect(() => {
		if (!detailFetchTrigger) return;
		const fetchAllDetailsForSelectedRow = async () => {
			const wmsOrderNo = editKSK1030_R01?.wmsOrderNo;
			if (!wmsOrderNo) {
				setKSK1030_R01DetailList([]);
				setOriginalKSK1030_R01DetailList([]);
				setKSK1030_R01LotList([]);
				setOriginalKSK1030_R01LotList([]);
				prevWmsOrderNoRef.current = undefined;
				setDetailFetchTrigger(false);
				return;
			}

			const previousOrderNo = prevWmsOrderNoRef.current;
			const previousWarehouseCd = prevWarehouseCdRef.current;

			const headerData = await fetchOne();
			const apiHeaderData = await fetchTransportHeader();
			if (apiHeaderData) setTransportComplete(true);
			else setTransportComplete(false);

			const baseDataForDefaults = { ...defaultKSK1030_R01HeaderRow(), ...headerData, ...(apiHeaderData || {}) };
			const defaultValues = handleDetailInfoCode(baseDataForDefaults);

			const logicCenterToUse = baseDataForDefaults.logicCenter || defaultValues.logicCenter || '';
			const warehouseCdToUse = baseDataForDefaults.warehouseCd || defaultValues.warehouseCd || '';
			const isNewSelection = previousOrderNo !== wmsOrderNo || previousWarehouseCd !== warehouseCdToUse;

			setEditKSK1030_R01({
				...defaultKSK1030_R01HeaderRow(),
				...headerData,
				...defaultValues,
				logicCenter: logicCenterToUse,
				warehouseCd: warehouseCdToUse,
				inoutClass: '230',
			});

			const updatedDetailList = await handleFetchDetailList(wmsOrderNo, warehouseCdToUse, isNewSelection, previousOrderNo);
			if (updatedDetailList && updatedDetailList.length > 0) {
				await handleFetchLotList();
			}
			prevWmsOrderNoRef.current = wmsOrderNo;
			prevWarehouseCdRef.current = warehouseCdToUse;
			setDetailFetchTrigger(false);
		};

		fetchAllDetailsForSelectedRow();
	}, [detailFetchTrigger, editKSK1030_R01?.wmsOrderNo, setEditKSK1030_R01, setLoadingSpinner]);

	// LotMap inputOutQty 합 → Detail updateTransportQty 동기화
	useEffect(() => {
		const lotQtySums = new Map<string, number>();
		KSK1030_R01LotMap.forEach((lots, key) => {
			const sum = lots.reduce((acc, lot) => {
				if (deletedKSK1030_R01LotList.includes(lot.valueIndex.toString())) return acc;
				return acc + Number(lot.inputOutQty || 0);
			}, 0);
			lotQtySums.set(key, sum);
		});

		const needsUpdate = KSK1030_R01DetailList.some(detailItem => {
			const sum = lotQtySums.get(`${detailItem.itemCd}-${detailItem.itemStatus}`);
			return sum !== undefined && detailItem.updateTransportQty !== sum;
		});

		if (needsUpdate) {
			const newDetailList = KSK1030_R01DetailList.map(detailItem => {
				const sum = lotQtySums.get(`${detailItem.itemCd}-${detailItem.itemStatus}`);
				if (sum !== undefined && detailItem.updateTransportQty !== sum) {
					return { ...detailItem, updateTransportQty: sum };
				}
				return detailItem;
			});
			setKSK1030_R01DetailList(newDetailList);
		}
	}, [KSK1030_R01LotMap, deletedKSK1030_R01LotList, KSK1030_R01DetailList, setKSK1030_R01DetailList]);

	return {
		clickable, setClickable,
		handleExcelClick,
		fetchSelectedOrder,
		handleSearchClick,
		defaultKSK1030_R01HeaderRow,
		defaultKSK1030_R01DetailRow,
		defaultKSK1030_R01LotRow,
		initContainerData,
		handleDeleteClick,
		handleInsertClick,
		handleSaveClick,
		warehouseCdListToUseList,
		handleDetailInfoCode,
		handleFetchDetailList,
		handleFetchLotList,
		getWmsOrderFieldHandlers,
	};
};
